import { useState } from 'react';

type InputComment = [
  {
    body: string;
    error: boolean;
  },
  {
    setComment: (comment: string) => void;
  },
];

export const inputCommentLimit = 5000;

const useInputComment = (comment: string): InputComment => {
  const [inputComment, setInputComment] = useState({
    body: comment,
    error: false,
  });

  const setComment = (comment: string): void => {
    setInputComment({
      body: comment,
      error: validationComment(comment),
    });
  };

  const validationComment = (comment: string): boolean => {
    return comment.length > inputCommentLimit;
  };

  return [inputComment, { setComment }];
};

export default useInputComment;
